import ClearIcon from "@mui/icons-material/Clear";
import SearchIcon from "@mui/icons-material/Search";
import {
  CircularProgress,
  InputAdornment,
  TextField
} from "@mui/material";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { validarCuilCuit } from "../../../util/cuilcuit";
import StyledSearchCuil from "../../styled/SearchCuil";

const Search = ({ clearActions, reduxAction, callBack, onClear, data }) => {
  const dispatch = useDispatch();

  const [inputValue, setInputValue] = useState("");

  const handleSearch = () => {
    if (inputValue && validarCuilCuit(inputValue)) {
      clearActions.forEach((action) => {
        dispatch(action());
      });
      dispatch(reduxAction(inputValue));
      if (callBack) {
        callBack(inputValue);
      }
    } else {
      toast.error(
        "Por favor, ingrese un CUIL válido para continuar con la búsqueda"
      );
    }
  };

  const handleClear = () => {
    setInputValue("");
    if (onClear) {
      onClear();
    }
  };

  const handleInputChange = (event) => {
    setInputValue(event.target.value);
  };

  return (
    <StyledSearchCuil.SearchContainer>
      <TextField
        id="cuil"
        name="cuil"
        type="text"
        label="CUIL"
        variant="outlined"
        value={inputValue}
        onChange={handleInputChange}
        FormHelperTextProps={{
          style: {
            display: "none",
          },
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end">
              <ClearIcon onClick={handleClear} />
            </InputAdornment>
          ),
        }}
      ></TextField>
      <StyledSearchCuil.Button
        type="submit"
        color="primary"
        variant="contained"
        onClick={handleSearch}
      >
        {data.loading ? (
          <CircularProgress size={24} color="inherit" />
        ) : (
          "Buscar"
        )}
      </StyledSearchCuil.Button>
    </StyledSearchCuil.SearchContainer>
  );
};

export default Search;
